import React from 'react'

const AdminGlobalStateContext = React.createContext()

export function useAdminGlobalStateContext() {
  const data = React.useContext(AdminGlobalStateContext)

  if (data === undefined) {
    throw new Error(
      'useAdminGlobalStateContext must be used with in AdminGlobalStateContext'
    )
  }
  return data
}

export default AdminGlobalStateContext